import { render, staticRenderFns } from "./GraphQlDataComponent.vue?vue&type=template&id=3a72bc68&scoped=true&"
import script from "./GraphQlDataComponent.vue?vue&type=script&lang=js&"
export * from "./GraphQlDataComponent.vue?vue&type=script&lang=js&"
import style0 from "./GraphQlDataComponent.vue?vue&type=style&index=0&id=3a72bc68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a72bc68",
  null
  
)

export default component.exports